module.exports = __webpack_public_path__ + "d8a19630511bbd0cac5a1467f0ad7518.pdf";